import React, { useEffect } from 'react';
import { createSearchPanel, attractionsCreateSearchPanel } from '@utils/creaeteSearchPanel';
import styles from './styles.module.scss';

interface I_Route {
    href: string | undefined;
    text: string;
    spliter?: string;
}

interface I_Props {
    routes?: I_Route[];
}

const SearchPanelBlock: React.FC<I_Props> = ({ routes }) => {
    useEffect(() => {
        createSearchPanel({ device: 'PC' });
    }, []);

    return (
        <div className={styles.searchPanel_wrapper}>
            <div className={styles.breadcrumb}>
                {routes?.map((anchor: I_Route, i: number) => (
                    <span className={styles.anchor} key={i}>
                        {i !== 0 && (anchor.spliter || ` > `)}
                        {anchor.href ? (
                            <a className={styles.anchorText} href={anchor.href}>
                                {anchor.text}
                            </a>
                        ) : (
                            <span className={styles.anchorText}>{anchor.text}</span>
                        )}
                    </span>
                ))}
                <div id="SearchPanel" />
            </div>
        </div>
    );
};

export default SearchPanelBlock;

// export const AttractionsSearchPanelBlock: React.FC<I_Props> = ({ routes }) => {
//     useEffect(() => {
//         attractionsCreateSearchPanel({ device: 'PC' });
//     }, []);

//     return (
//         <div className={styles.searchPanel_wrapper}>
//             <div className={styles.breadcrumb}>
//                 {routes?.map((anchor: I_Route, i: number) => (
//                     <span className={styles.anchor} key={i}>
//                         {i !== 0 && (anchor.spliter || ` > `)}
//                         {anchor.href ? (
//                             <a className={styles.anchorText} href={anchor.href}>
//                                 {anchor.text}
//                             </a>
//                         ) : (
//                             <span className={styles.anchorText}>{anchor.text}</span>
//                         )}
//                     </span>
//                 ))}
//                 <div id="SearchPanel" />
//             </div>
//         </div>
//     );
// };
